import { IFlag } from './IFlag';

export { IFlag };
